(() => {
  const root = document.getElementById('ptd-signature');
  if (!root) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection && navigator.connection.saveData;
  const videos = [...root.querySelectorAll('[data-ptd-video]')];
  const load = video => {
    if (!video.getAttribute('src') && video.dataset.src) {
      video.src = video.dataset.src;
      video.load();
    }
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target: video, isIntersecting}) => {
      if (isIntersecting && !reduced && !saveData && !video.dataset.userPaused) {
        load(video);
        if (video.src) video.play().catch(() => {});
      } else if (!isIntersecting) video.pause();
    });
  }, {threshold: 0.25}) : null;
  videos.forEach(video => {
    const button = video.parentElement.querySelector('[data-ptd-play]');
    if (!video.dataset.src) { button.hidden = true; return; }
    const update = () => {
      button.textContent = video.paused ? 'Film abspielen ▷' : 'Pause Ⅱ';
      button.setAttribute('aria-label', video.paused ? 'Film abspielen' : 'Film pausieren');
    };
    video.addEventListener('play', update);
    video.addEventListener('playing', () => video.parentElement.classList.add('ptd-is-playing'));
    video.addEventListener('error', () => video.parentElement.classList.remove('ptd-is-playing'));
    video.addEventListener('pause', update);
    button.addEventListener('click', () => {
      if (video.paused) { delete video.dataset.userPaused; load(video); video.play().catch(() => {}); }
      else { video.dataset.userPaused = '1'; video.pause(); }
    });
    if (observer) observer.observe(video);
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) videos.forEach(video => video.pause());
  });
  let pendingOccasion = '';
  let pendingStart = false;
  const applyOccasion = () => {
    if (!pendingOccasion) return;
    const field = document.getElementById('pt-entry-name');
    if (field && field.dataset.ptqTextSlot === 'message' && !field.hidden) {
      field.value = pendingOccasion;
      field.dispatchEvent(new Event('input', {bubbles: true}));
      pendingOccasion = '';
    }
  };
  const startEntry = () => {
    const entry = document.getElementById('pt-unified-entry');
    const target = entry && entry.querySelector('.pt-entry-mode--tree');
    if (target && !target.disabled) {
      if (target.getAttribute('aria-pressed') !== 'true') target.click();
      if (pendingOccasion && document.getElementById('pt-entry-name').hidden) {
        entry.querySelector('.pt-entry-back').click();
      }
      applyOccasion();
      entry.scrollIntoView({behavior:reduced ? 'auto' : 'smooth',block:'start'});
      pendingStart = false;
      return true;
    }
    return false;
  };
  const onMounted = () => {
    const entry = document.getElementById('pt-unified-entry');
    if (!entry || entry.dataset.ptdObserved) return;
    entry.dataset.ptdObserved = '1';
    const slot = root.querySelector('.ptd-entry-slot');
    if (slot) slot.appendChild(entry);
    const engine = document.getElementById('pt-quick-b2c');
    if (engine) engine.dataset.ptEntryExternal = '1';
    const field = document.getElementById('pt-entry-name');
    new MutationObserver(applyOccasion).observe(field, {attributes:true,attributeFilter:['data-ptq-text-slot','hidden']});
    if (pendingStart) startEntry();
  };
  window.addEventListener('pt:entry-mounted', onMounted);
  onMounted();
  root.querySelectorAll('[data-ptd-buy]').forEach(link => link.addEventListener('click', event => {
    if (link.dataset.ptdOccasion) {
      pendingOccasion = link.dataset.ptdOccasion;
      const context = root.querySelector('[data-ptd-context]');
      if (context) {context.textContent = 'Dein Anlass: ' + pendingOccasion + ' · Dein Zertifikat lässt sich anschließend frei gestalten.'; context.hidden = false;}
    }
    pendingStart = true;
    if (startEntry()) event.preventDefault();
  }));
  // One mobile purchase bar reserves a separate, clickable space for Wurzelbert.
  const purchase = root.querySelector('.ptd-purchase');
  const hero = root.querySelector('.ptd-hero');
  const giftDock = document.createElement('div');
  giftDock.className = 'pt-signature-giftbar';
  giftDock.hidden = true;
  giftDock.innerHTML = '<a href="#dirndlkoenigin-kaufen"><span class="pt-giftbar-summary"><strong class="pt-giftbar-price"></strong><span>Baum &amp; Zertifikat</span></span><span class="pt-giftbar-action">Jetzt kaufen <span aria-hidden="true"><svg class="pt-product-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 19 19 5M5 5h14v14"/></svg></span></span></a>';
  const price = root.querySelector('.ptd-price strong');
  giftDock.querySelector('.pt-giftbar-price').textContent = price ? price.textContent.trim().replace(/^€\s*(.*)/, '$1 €') : '';
  document.body.appendChild(giftDock);
  giftDock.querySelector('a').addEventListener('click', event => {
    pendingStart = true;
    if (startEntry()) event.preventDefault();
  });
  let launcher;
  let frame;
  const hideGiftDock = () => {
    giftDock.hidden = true;
    document.body.classList.remove('pt-signature-giftbar-visible');
  };
  const updateGiftDock = () => {
    frame = 0;
    const editor = document.getElementById('pt-quick-b2c');
    const rect = purchase && purchase.getBoundingClientRect();
    const activeInput = document.activeElement && /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName);
    const visible = matchMedia('(max-width: 760px)').matches && hero && rect &&
      hero.getBoundingClientRect().bottom < 0 && (rect.top > innerHeight || rect.bottom < 0) &&
      !(launcher && launcher.getAttribute('aria-expanded') === 'true') && !activeInput &&
      !(editor && editor.dataset.ptqFocusMode === '1') && !document.querySelector('dialog[open]');
    if (!visible) { hideGiftDock(); return; }
    document.body.classList.add('pt-signature-giftbar-visible');
    const pet = launcher && launcher.getBoundingClientRect();
    giftDock.style.setProperty('--pt-giftbar-pet-space', Math.ceil(pet && pet.width ? pet.right + 12 : 88) + 'px');
    giftDock.hidden = false;
  };
  const scheduleGiftDock = () => {if (!frame) frame = requestAnimationFrame(updateGiftDock);};
  const stateObserver = new MutationObserver(scheduleGiftDock);
  const connectLauncher = () => {
    if (launcher) return;
    launcher = document.querySelector('.pt-chat-button');
    if (!launcher) return;
    stateObserver.observe(launcher, {attributes:true,attributeFilter:['aria-expanded','class','style']});
    if ('ResizeObserver' in window) new ResizeObserver(scheduleGiftDock).observe(launcher);
    scheduleGiftDock();
  };
  new MutationObserver(connectLauncher).observe(document.body, {childList:true,subtree:true});
  connectLauncher();
  stateObserver.observe(root, {subtree:true,attributes:true,attributeFilter:['data-ptq-focus-mode','open']});
  window.addEventListener('scroll', scheduleGiftDock, {passive:true});
  window.addEventListener('resize', scheduleGiftDock, {passive:true});
  if (window.visualViewport) window.visualViewport.addEventListener('resize', scheduleGiftDock, {passive:true});
  document.addEventListener('focusin', scheduleGiftDock);
  document.addEventListener('focusout', scheduleGiftDock);
  scheduleGiftDock();
})();

